/*
  We only want to extract the text from the rich text fields. This is used to reduce the final size of the
  page-data.json (this file will be requested client side and will house the resource center data). We also need
  to do this so we don't search on a body with HTML tags.
*/

let { BLOCKS, INLINES, MARKS } = require('@contentful/rich-text-types')

//RICH TEXT OPTIONS

const options = (references?: any) => {
  return {
    renderMark: {
      [MARKS.BOLD]: (text: any) => text,
      [MARKS.ITALIC]: (text: any) => text,
      [MARKS.UNDERLINE]: (text: any) => text,
      [MARKS.CODE]: (text: any) => text,
    },
    renderNode: {
      [BLOCKS.HEADING_1]: (node: any, next: any) => {
        return next(node.content)
      },
      [BLOCKS.HEADING_2]: (node: any, next: any) => {
        return next(node.content)
      },
      [BLOCKS.HEADING_3]: (node: any, next: any) => {
        return next(node.content)
      },
      [BLOCKS.HEADING_4]: (node: any, next: any) => {
        return next(node.content)
      },
      [BLOCKS.HEADING_5]: (node: any, next: any) => {
        return next(node.content)
      },
      [BLOCKS.HEADING_6]: (node: any, next: any) => {
        return next(node.content)
      },
      // add space after every paragraph
      [BLOCKS.PARAGRAPH]: (node: any, next: any) => {
        return `${next(node.content)} `
      },
      [BLOCKS.OL_LIST]: (node: any, next: any) => {
        return next(node.content)
      },
      [BLOCKS.UL_LIST]: (node: any, next: any) => {
        return next(node.content)
      },
      [BLOCKS.LIST_ITEM]: (node: any, next: any) => {
        return next(node.content)
      },
      [BLOCKS.QUOTE]: (node: any, next: any) => {
        return `${next(node.content)} `
      },
      [BLOCKS.EMBEDDED_ENTRY]: () => '',
      [BLOCKS.EMBEDDED_ASSET]: () => '',
      [INLINES.EMBEDDED_ENTRY]: () => '',
      [INLINES.ASSET_HYPERLINK]: () => '',
      [INLINES.ENTRY_HYPERLINK]: (node: any, next: any) => {
        return next(node.content)
      },
      [INLINES.HYPERLINK]: (node: any, next: any) => {
        return next(node.content)
      },
    },
  }
}

export default options
